import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import APIService from '../../Services/APIService';
import CommonTable from '../Shared/Tables/TableV1.tsx';
import { Box, Button, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const Suppliers = () => {
  const { campaignId } = useParams();
  const navigate = useNavigate();
  const [currentCampaign, setCurrentCampaign] = useState({});
  const [supplierStatic, setSupplierStatic] = useState([]);

  function onBack() {
    navigate(`/r/checklist/campaigns`);
  }

  const renderSupplierRow = (supplier, index) => {
    return (
      <tr key={supplier.supplier_id}>
        <td className="hidden-xs">{index + 1}</td>
        <td className="supplier-name">{supplier.name}</td>
        <td>{supplier.area}</td>
        <td>{supplier.subarea}</td>
        <td>
          {supplier.address1} {supplier.address2}
        </td>
        <td>
          <Link
            to={`/r/checklist/list/${campaignId}/${supplier.supplier_id}`}
            className="btn btn--danger"
          >
            View checklists
          </Link>
        </td>
      </tr>
    );
  };

  const getCurrentCampaign = async (id) => {
    let res = await APIService.get(`/v0/ui/website/${id}/campaign-inventories/`);
    if (res.status == 200) setCurrentCampaign(res.data);
  };

  const getSuppliersList = async (id) => {
    let res = await APIService.get(`/v0/ui/website/proposal/${id}/shortlisted_suppliers/`);
    if (res.status == 200) {
      let suppliers = [];
      const data = res.data;
      const dataKeys = Object.keys(data);
      if (dataKeys.indexOf('dynamic_suppliers') > 0) {
        dataKeys.splice(dataKeys.indexOf('dynamic_suppliers'), 1);
      }
      for (let i = 0, l = dataKeys.length; i < l; i += 1) {
        const supplierGroups = data[dataKeys[i]].suppliers;
        const supplierGroupsKeys = Object.keys(supplierGroups);
        for (let j = 0, sl = supplierGroupsKeys.length; j < sl; j += 1) {
          suppliers = suppliers.concat(supplierGroups[supplierGroupsKeys[j]]);
        }
      }
      if (data && data.dynamic_suppliers && data.dynamic_suppliers.length) {
        suppliers = suppliers.concat(data.dynamic_suppliers);
      }
      setSupplierStatic(suppliers);
    }
  };

  useEffect(() => {
    if (campaignId) {
      getCurrentCampaign(campaignId);
      getSuppliersList(campaignId);
    }
  }, []);

  const columns = [
    {
      accessorKey: 'index',
      header: 'Index',
      Cell: ({ row }) => row.id + 1,
      size: 50,
      enableSorting: false,
    },
    {
      accessorKey: 'name',
      header: 'Name',
      enableSorting: false,
      size: 50,
    },
    {
      accessorKey: 'area',
      header: 'Area',
      enableSorting: false,
      size: 50,
    },
    {
      accessorKey: 'subarea',
      header: 'Sub-area',
      enableSorting: false,
      size: 50,
    },
    {
      accessorFn: (row) => `${row.address1 || ''} ${row.address2 || ''}`,
      id: 'address',
      header: 'Address',
      enableSorting: false,
      size: 50,
    },
    {
      accessorKey: 'action',
      header: 'Action',
      enableSorting: false,
      size: 50,
      Cell: ({ row }) => (
        <Link
          to={`/r/checklist/list/${campaignId}/${row.original.supplier_id}`}
          style={{
            color: 'blue',
            cursor: 'pointer',
            textDecoration: 'none',
          }}
        >
          View checklists
        </Link>
      ),
    },
  ];

  return (
    <Box sx={{ p: '5px' }}>
      <Typography variant="h5" gutterBottom>
        Suppliers of Business Service {currentCampaign?.campaign?.name || ''}
      </Typography>

      <Button
        variant="contained"
        color="primary"
        size="small"
        startIcon={<ArrowBackIcon />}
        onClick={onBack}
        sx={{ mb: 3 }}
      >
        Back
      </Button>

      <CommonTable
        columns={columns}
        data={supplierStatic || []}
        enableDensityToggle={false}
        enableBottomToolbar={true}
        enableTableFooter={true}
        enableStickyHeader={true}
      />
    </Box>
  );
};

export default Suppliers;
